function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close(event)
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('.js-recover-password').addEventListener(
      'click',
      this.showForgotPassword.bind(this)
    );
    this.querySelector('.cancel-recover-password').addEventListener(
      'click',
      this.hideForgotPassword.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  hideForgotPassword(){
    this.querySelector('.login-form').classList.remove('hidden')
    this.querySelector('.recover-password-form').classList.add('hidden')
  }

  showForgotPassword(){
    this.querySelector('.login-form').classList.add('hidden')
    this.querySelector('.recover-password-form').classList.remove('hidden')
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen()
      ? this.close(event)
      : this.open(event);
  }

  onBodyClick(event) {
    if (event.target.classList.contains('modal-overlay')) {
      this.close(event,false);
    }
  }

  open(event,ignoreBodyClick) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);

      console.log('open')
    this.detailsContainer.setAttribute('open', true);

    //Allows for animation on details close
    this.detailsContainer.classList.add('is-open');
    //Allows for animation on details close


    document.body.addEventListener('click', this.onBodyClickEvent);
    
    
    document.body.classList.add('overflow-hidden');

    let isSticky = document.querySelector('.is-sticky');
    if (isSticky){
      isSticky.classList.remove('is-sticky');
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(event,focusToggle = true) {
    //Allows for animation on details close
    event.preventDefault(); 
    this.detailsContainer.classList.remove('is-open')
    
    setTimeout(() => { 
      this.detailsContainer.removeAttribute("open"); 
    }, 600);
    //Allows for animation on details close

    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

// customElements.define('details-modal', DetailsModal);

class LoginModal extends DetailsModal {
  constructor() {
    super();

    if (window.location.hash == '#login'){
      this.open();
    }

  }

}

customElements.define('login-modal', LoginModal);

document.addEventListener("DOMContentLoaded", function(event) {
  let loginLinks = document.querySelectorAll('a[href="/account/login"]');
  let loginModal = document.querySelector('login-modal');

  for (var i = 0; i < loginLinks.length; i++) {
    let link = loginLinks[i]
    link.addEventListener('click', (event)=>{
      event.preventDefault();
      if (loginModal){
        loginModal.open(event,true);
      }
      else {
        window.location.href = event.currentTarget.href;
      }
      
    });
  }

});
